import { createAction, props } from '@ngrx/store';
import { ILocalidad } from '../../models/ILocalidad';

export const loadLocalidades = createAction('Load Localidades');

export const loadedLocalidadesError = createAction('Load Localidades Error', props<{ error: any }>());

export const loadedLocalidadesSuccess = createAction(
	'Load Localidades Success',
	props<{ localidades: ILocalidad[] }>()
);
